import { createContext } from 'react';

const CoreFormMenuContext = createContext(null);

export default CoreFormMenuContext;
